<template>
  <footer class="main-footer">
    <div class="footer-content">
      <a href="http://www.raisetech.com.np" class="footer-link">eCalculo ERP.</a>
      <p class="footer-copy">
        Copyright &copy; {{ year }}
      </p> 
      <p class="footer-right">
        All rights reserved
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'DashFooter',
  data: function () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
<style>
.main-footer {
    background: transparent;
    padding: 15px;
    color: #444;
    margin-left: 0;
    /* border-top: 1px  solid #ecf0f5 !important; */
}
.footer-content > * {
  margin-bottom: 0;
}
.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.footer-link,.footer-copy {
  font-weight: 700;
}
.footer-link {
  color: #043d75;
}
.footer-content > p {
  text-transform: uppercase;
}
.footer-copy,
.footer-right {
  font-size: 1.4rem;
  letter-spacing: 0.1em;
}
.footer-right {
  font-weight: 300;
}
@media print {
  .main-footer {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// DashFooter.vue?7196c9c1